import { render, staticRenderFns } from "./PeerView.vue?vue&type=template&id=6c7ba9c7&scoped=true&"
import script from "./PeerView.vue?vue&type=script&lang=js&"
export * from "./PeerView.vue?vue&type=script&lang=js&"
import style0 from "./PeerView.vue?vue&type=style&index=0&id=6c7ba9c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7ba9c7",
  null
  
)

export default component.exports